import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import { IndividualDetails } from "../types/Individual";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../routes";

const fetch = (authHeader: string, individualId: number) => () =>
  axios.get<IndividualDetails>(
    `${env.verifyServiceUrl}individual/individual_v2/${individualId}/`,
    {
      headers: {
        Authorization: authHeader,
      },
    }
  );

export const useIndividual = (id) => {
  const { authHeader } = useAuth();
  const navigate = useNavigate();
  return useQuery(["individual", id], fetch(authHeader, id), {retry: false,
    onError: (err: any) => {
      if(err.request.status === 500 || err.request.status === 503) {
        navigate(ROUTE.SERVER_ERROR);
      }
    }
  });
};
